module.exports = __webpack_public_path__ + "static/pid-ug-13-en-authrequest-ff5910c742f8be5dec3296e2d86af6c1.png";